import { render, staticRenderFns } from "./DrivingLessonTaskGroupCreateModal.vue?vue&type=template&id=4625bc6c&"
import script from "./DrivingLessonTaskGroupCreateModal.vue?vue&type=script&lang=ts&"
export * from "./DrivingLessonTaskGroupCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports